<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" (onHide)="onMainDialogHide()" [draggable]="false"
  [resizable]="false" [style]="{ width: '53rem' }" styleClass="intake-dialog" maskStyleClass="intake-dialog-mask">
  <ng-template #header>
    <span class="intake-eyebrow">Property Intake Form</span>
    <img src="assets/images/x-circle.png" alt="close" (click)="onMainDialogHide()" class="intake-close-icon" />
  </ng-template>

  @if (confirming()) {
  <div class="intake-confirm-panel">
    <div class="confirm-dlg-body">
      <span class="intake-confirm-icon"><i class="pi pi-home"></i></span>
      <h3 class="intake-confirm-title">Confirm Submission</h3>
      <p class="intake-confirm-message">Please confirm that all the information you have provided is accurate and
        complete. Once submitted, our team will begin reviewing your property.</p>
    </div>
    <div class="intake-confirm-actions">
      <button pButton type="button" label="Review Again" class="btn btn--taupe-light" [disabled]="isSaving()"
        (click)="cancelConfirm()"></button>
      <button pButton type="button" label="Yes, Submit" class="btn btn--primary" [loading]="isSaving()"
        (click)="submit()"></button>
    </div>
  </div>
  } @else {
  <h2 class="intake-step-title">{{ stepTitles[currentStep()] }}</h2>

  <div class="intake-body">
    @switch (currentStep()) {
    @case (1) {
    <krc-contact-property-step [form]="contactPropertyForm" />
    <krc-intended-use-step [form]="intendedUseForm" />
    }
    @case (2) {
    <krc-review-step [contactProperty]="contactPropertyForm.getRawValue()"
      [projectPurpose]="projectPurposeForm.getRawValue()" [intendedUse]="intendedUseForm.getRawValue()"
      [preferredContact]="contactPropertyForm.getRawValue().preferredContact" [uploads]="uploads()"
      [consentForm]="consentForm" (editStep)="goToStep($event)" (submitForm)="confirmSubmit()" />
    }
    }
  </div>

  <div class="intake-footer" [ngClass]="currentStep() === 1 ? 'intake-footer--step-1' : ''">
    @if (currentStep() > 1) {
    <button pButton type="button" label="Previous" class="btn btn--taupe-light" [disabled]="isSaving()"
      (click)="goPrevious()"></button>
    }

    @if (currentStep() < totalSteps) { <button pButton class="btn btn--sage" [label]="isSaving() ? 'Saving…' : 'Next'"
      [loading]="isSaving()" (click)="goNext()"></button>
      } @else {
      <button pButton type="button" class="btn btn--primary" [label]="isSaving() ? 'Submitting…' : 'Submit Request'"
        [loading]="isSaving()" [disabled]="consentForm.invalid" (click)="confirmSubmit()"></button>
      }
  </div>
  }
</p-dialog>

<krc-submit-error-dialog [(visible)]="errorDialogVisible" [isSaving]="isSaving()" (contactSupport)="contactKore()"
  (retry)="retry()" />

<krc-submit-success-dialog [(visible)]="successDialogVisible" (contactKore)="contactKore()" (backToHome)="close()" />
